import { Box, Popover, Stack } from '@mui/material';
import { Dispatch, SetStateAction, useContext } from 'react';
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
} from 'react-share';
import {
    Email as EmailIcon,
    Facebook as FacebookIcon,
    LinkedIn as LinkedInIcon,
    Twitter as TwitterIcon,
} from '@mui/icons-material';

import { secondaryColor } from '../../core/themes/colors';
import { SharePollContent } from '../../../content/share_poll_content';
import { SessionContext, SessionContextType } from '../../../contexts/session';
import {
    AnonymousUserContext,
    AnonymousUserContextType,
} from '../../../contexts/anonUser';

interface ShareSiteProps {
    anchorEl: HTMLElement | null;
    setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
}

const ShareSite = (props: ShareSiteProps): JSX.Element => {
    const { session } = useContext<SessionContextType>(SessionContext);
    const { anonUser } =
        useContext<AnonymousUserContextType>(AnonymousUserContext);
    const shareURL = `${new URL(window.location.href).origin}?ref=${String(
        session.user?.id ?? anonUser.user?.id,
    )}`;

    const onMouseLeaveHandler = () => {
        props.setAnchorEl(null);
    };

    return (
        <Popover
            open={Boolean(props.anchorEl)}
            anchorEl={props.anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            onClose={onMouseLeaveHandler}
            disableRestoreFocus
        >
            <Box
                sx={{
                    px: '1rem',
                    pt: '0.4rem',
                    pb: '0.2rem',
                    color: secondaryColor,
                }}
            >
                <Stack direction='row' spacing={2}>
                    <FacebookShareButton
                        url={shareURL}
                        quote={SharePollContent.facebook.quote}
                    >
                        <FacebookIcon fontSize='large' />
                    </FacebookShareButton>
                    <LinkedinShareButton
                        url={shareURL}
                        title={SharePollContent.linkedin.title}
                        summary={SharePollContent.linkedin.summary}
                        source={SharePollContent.linkedin.source}
                    >
                        <LinkedInIcon fontSize='large' />
                    </LinkedinShareButton>
                    <TwitterShareButton
                        url={shareURL}
                        title={SharePollContent.twitter.title}
                    >
                        <TwitterIcon fontSize='large' />
                    </TwitterShareButton>
                    <EmailShareButton
                        url={shareURL}
                        subject={SharePollContent.email.subject}
                        body={SharePollContent.email.body}
                    >
                        <EmailIcon fontSize='large' />
                    </EmailShareButton>
                </Stack>
            </Box>
        </Popover>
    );
};

export default ShareSite;
